import { useEffect, useState } from "react";
import NoRecord from "../../form/NoRecord";
import { useDispatch, useSelector } from "react-redux";
import ReactPagination from "../../table/ReactPagination";
import PaginationDropdown from "../../table/PaginationDropdown";
import {
  fetchMyProjects,
  fetchProjectDeliveableHireDetails,
  fetchProjectDetails,
  markAsComplete,
  uploadDeliveableProject,
} from "../../../redux/features/hire-talent/actions/projectAction";
import { setIsViewProjectDetails } from "../../../redux/features/hire-talent/reducers/projectReducer";
import ProjectDetails from "../../Modals/common/project/ProjectDetails";
import MarkCompleteConfirmationModal from "../../Modals/hire-talent/MarkCompleteConfirmationModal";
import UploadDeliveableModal from "../../Modals/hire-talent/UploadDeliveableModal";

const Projects = ({ activeTab, setIsSuccess, isSuccess, setSelectProject, selectProject }) => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(0);
  const [listPerPages, setListPerPages] = useState(5);
  const [projectId, setProjectId] = useState("");
  const [confirmation, setConfirmation] = useState(false);
  const [isUpload, setIsUpload] = useState(false);
  const { projectList, isViewProjectDetails, deliveableList } = useSelector(
    (state) => state?.hireTalent?.project
  );

  const paginatedList =
    projectList?.[activeTab]?.slice(
      currentPage * listPerPages,
      (currentPage + 1) * listPerPages
    ) || [];

  const handlePageClick = (data) => {
    setCurrentPage(data?.selected);
  };

  const handleMarkAsComplete = (project_id) => {
    const callback = (res) => {
      if (res?.success) {
        setIsSuccess(true);
        dispatch(fetchMyProjects());
      } else {
        setIsSuccess(false);
      };
    };
    dispatch(
      markAsComplete({
        payload: { project_id },
        callback,
      })
    );
  };

  const handleUploadDeliveablesData = (values) => {
    const callback = (response) => {
      dispatch(fetchMyProjects());
      setSelectProject(selectProject);
    };
    const formData = new FormData();
    formData.append("project_id", selectProject);
    values.comment && formData.append("comment", values.comment);
    values.link && formData.append("links", values.link);
    values?.files?.length != 0 &&
      values?.files?.map((item) => (
        formData.append("files", item)
      ))
    dispatch(uploadDeliveableProject({ payload: formData, callback }));
  };

  return (
    <div className="row gx-md-3">
      {paginatedList?.length > 0 && (
        <>
          {paginatedList?.map((item, index) => (
            <div className="col-lg-4 col-md-6 ct_mb_16 ct_cursor_pointer" onClick={() => setSelectProject(item?.id)}>
              <div className={`ct_outline_bg h-100  ct_py_20_px_30 ct_border_radius_10 d-grid ${selectProject == item?.id && "ct_card_active"}`}>
                <div>
                  <div className="d-flex align-items-start gap-3 justify-content-between">
                    <div className="ct_flex_1">
                      <h4 className="ct_fs_18 ct_darkblue_text ct_mb_10">
                        {item?.project_title || ""}
                      </h4>
                      <p
                        className="mb-0 ct_fs_14 ct_grey_text ct_para_scroll ct_custom_scroll"
                        style={{ maxHeight: "80px" }}
                      >
                        {item?.project_description || ""}
                      </p>
                    </div>

                    <div class="ct_right_dropdown dropdown">
                      <button
                        id="dropdownMenuButton"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        className="ct_project_action_elipse_icon"
                      >
                        <i class="fa-solid fa-ellipsis"></i>
                      </button>
                      <ul
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        <li>
                          <a
                            class="dropdown-item"
                            onClick={(e) => {
                              e.preventDefault();
                              dispatch(
                                fetchProjectDetails({ payload: item?.id })
                              );
                              dispatch(
                                fetchProjectDeliveableHireDetails({ payload: item?.id })
                              );
                            }}
                          >
                            View Project Details
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item ct_darksky_blue_text"
                            onClick={() => setIsUpload(true)}
                          // data-bs-target="#ct_Upload_Deliverable_modal"
                          // data-bs-toggle="modal"
                          // href="javascript:void(0)"
                          >
                            Upload Deliverable
                          </a>
                        </li>
                       {/*  <li>
                          <a
                            class="dropdown-item ct_yellow_text"
                            href="javascript:void(0)"
                          >
                            Send Message
                          </a>
                        </li>
                        <li>
                        <a
                          class="dropdown-item ct_orange_text"
                          data-bs-target="#ct_markas_complete_modal"
                          data-bs-toggle="modal"
                          onClick={() => {
                            setProjectId(item?.id)
                          }}
                          href="javascript:void(0)"
                        >
                          Mark as Complete
                        </a>
                      </li> */}
                      </ul>
                    </div>
                  </div>
                  <div className="ct_mt_16">
                    <ul className="d-flex align-items-center gap-2 flex-wrap">
                      {item?.project_categories?.map((cat) => (
                        <li>
                          <span
                            className="ct_badge ct_border_radius_10 ct_fs_14 d-inline-block  ct_darksky_blue_text"
                            style={{
                              backgroundColor:
                                "hsl(199.09deg 63.77% 72.94% / 10%)",
                              borderColor: "#E1E4EA",
                            }}
                          >
                            {cat}
                          </span>
                        </li>
                      ))}
                    </ul>
                    <p className="ct_fs_14 ct_grey_text ct_mt_16">
                      Assigned To :{" "}
                      {item?.assigned_to?.length
                        ? item.assigned_to
                          .map((obj) =>
                            `${obj?.first_name || ""} ${obj?.last_name || ""
                              }`.trim()
                          )
                          .join(", ")
                        : "#N/A"}
                    </p>
                  </div>
                  <div className="d-flex align-items-center justify-content-between gap-3 mt-2">
                    <div className="d-flex align-items-center gap-2">
                      <img src="../assets/img/grey_clock_icon.svg" />
                      <p className="mb-0 ct_fs_12 ct_grey_text">
                        {`${item?.project_duration} ${item?.duration_type}` ||
                          ""}
                      </p>
                    </div>
                    {/* <p className="mb-0 ct_fs_12 ct_grey_text">D-10</p> */}
                  </div>
                </div>

                <div className="mt-auto">
                  <div class="d-flex align-items-center gap-3 ct_mt_22">
                    <div class="progress ct_custom_progress ct_flex_1">
                      <div
                        class="progress-bar"
                        role="progressbar"
                        aria-valuenow="40"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style={{ width: `${item?.match_percentage}%` }}
                      ></div>
                    </div>
                    <span class="ct_white_nowrap">
                      {item?.match_percentage}%
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </>
      )}
      {paginatedList?.length == 0 && <NoRecord />}
      {paginatedList?.length > 0 && (
        <div className="d-flex justify-content-between align-items-center mt-4 ">
          <div>
            <PaginationDropdown
              onChange={(val) => {
                setListPerPages(val);
                setCurrentPage(0);
              }}
            />
          </div>
          <div>
            <ReactPagination
              pageCount={Math.ceil(
                projectList[activeTab]?.length / listPerPages
              )}
              onPageChange={handlePageClick}
              currentPage={currentPage}
            />
          </div>
        </div>
      )}
      {isViewProjectDetails && (
        <ProjectDetails
          onClose={() => {
            dispatch(setIsViewProjectDetails(false));
          }}
          setProjectId={setProjectId}
          setConfirmation={setConfirmation}
          deliveableList={deliveableList}
        />
      )}
      {confirmation && (
        <MarkCompleteConfirmationModal
          onClose={() => setConfirmation(false)}
          projectId={projectId}
          handleMarkAsComplete={(data) => handleMarkAsComplete(data)}
        />
      )}
      {isUpload &&
        <UploadDeliveableModal
          onClose={() => setIsUpload(false)}
          handleUploadDeliveablesData={handleUploadDeliveablesData}
        />
      }
      {/* Mark As Complete Confirmation */}
      <div
        class="modal fade ct_markas_complete_modal"
        id="ct_markas_complete_modal"
        tabindex="-1"
        aria-labelledby="ct_markas_complete_modalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content ct_border_radius_20">
            <div class="modal-header border-0">
              <button
                type="button"
                class="btn-close ct_circle_close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body pb-5 pt-0">
              <div class="mx-auto d-block text-center ct_mb_20">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                    fill="#FFB703"
                  />
                </svg>
              </div>
              <div class="text-center">
                <h4 class="ct_fs_18 ">Mark this Project as Complete?</h4>
                <p
                  className="ct_fs-14 ct_grey_text mb-0 mx-auto"
                  style={{ maxWidth: "388px" }}
                >
                  Confirm that you’ve finished this project. The client will be
                  notified for final review
                </p>
              </div>
              <div class="d-flex align-items-center gap-3 justify-content-center ct_mt_30 ">
                <button
                  class="ct_sky_blue_btn ct_yellow_btn ct_outline_grey  px-5 ct_h_44"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  Cancel
                </button>
                <button
                  class="ct_yellow_btn px-5 ct_h_44"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    handleMarkAsComplete(projectId);
                  }}
                  type="button"
                >
                  Mark as Complete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
